import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useLocale } from "../../context/LocaleContext";
import { track } from "../../lib/analytics";
import { Mascot } from "../../components/Mascot";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import Seo from "../../components/Seo";

export default function LoginPage() {
  const { login, formatApiError } = useAuth();
  const { t, lp } = useLocale();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const user = await login(email, password);
      track("login");
      navigate(user.role === "admin" || user.role === "editor" ? "/admin" : lp("/dashboard"));
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  }

  return (
    <div className="container-page flex min-h-[80vh] items-center justify-center py-12">
      <Seo title={`${t("login")} | LIVYVIO`} />
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
        <div className="flex items-center gap-2"><Mascot className="h-8 w-8" /><span className="font-heading text-xl font-extrabold">LIVYVIO</span></div>
        <h1 className="mt-6 font-heading text-2xl font-extrabold text-slate-900">{t("login")}</h1>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div><Label htmlFor="email">{t("email")}</Label><Input id="email" data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" /></div>
          <div><Label htmlFor="password">{t("password")}</Label><Input id="password" data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" /></div>
          {error && <p data-testid="login-error" className="text-sm text-red-600">{error}</p>}
          <Button type="submit" disabled={busy} data-testid="login-submit" className="w-full rounded-full bg-emerald-600 hover:bg-emerald-700">{busy ? "…" : t("login")}</Button>
        </form>
        <p className="mt-4 text-center text-sm text-slate-500">
          {t("register")}? <Link to={lp("/register")} className="font-semibold text-emerald-700">{t("register")}</Link>
        </p>
      </div>
    </div>
  );
}
